export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["card"] = "card";
})(PaymentMethodType || (PaymentMethodType = {}));
export var BankCardSystem;
(function (BankCardSystem) {
    BankCardSystem["visa"] = "visa";
    BankCardSystem["mastercard"] = "mastercard";
    BankCardSystem["maestro"] = "maestro";
    BankCardSystem["mir"] = "mir";
    BankCardSystem["unknown"] = "unknown";
})(BankCardSystem || (BankCardSystem = {}));
export var FrameOutMessageType;
(function (FrameOutMessageType) {
    FrameOutMessageType["callAction"] = "call_action";
})(FrameOutMessageType || (FrameOutMessageType = {}));
export var FrameMessageType;
(function (FrameMessageType) {
    FrameMessageType["success"] = "success";
    FrameMessageType["error"] = "error";
    FrameMessageType["abort"] = "abort";
    FrameMessageType["resize"] = "resize";
    FrameMessageType["discount"] = "discount";
    FrameMessageType["formReady"] = "form-ready";
    FrameMessageType["formStatus"] = "form-status";
    FrameMessageType["formSubmit"] = "form-submit";
    FrameMessageType["authStart"] = "auth-start";
    FrameMessageType["authEnd"] = "auth-end";
    FrameMessageType["initCheckout"] = "init-checkout";
    FrameMessageType["paymentComplete"] = "payment-complete";
    FrameMessageType["paymentFail"] = "payment-fail";
    FrameMessageType["paymentTimeout"] = "payment-timeout";
    FrameMessageType["paymentCancel"] = "payment-cancel";
    FrameMessageType["paymentPreview"] = "payment-preview";
    FrameMessageType["paymentLoaded"] = "payment-loaded";
    FrameMessageType["onResize"] = "on_resize";
    FrameMessageType["callActionResponse"] = "call_action_response";
})(FrameMessageType || (FrameMessageType = {}));
export var FrameMessageAbortReason;
(function (FrameMessageAbortReason) {
    FrameMessageAbortReason["user"] = "user";
    FrameMessageAbortReason["timeout"] = "timeout";
})(FrameMessageAbortReason || (FrameMessageAbortReason = {}));
